// Contexts
import { useProofIncomeContextConsumerHook } from 'containers/proof-income/contexts/proof-income.context';
import { useAppContextConsumerHook } from 'contexts/app.context';
import { useFetchErrorContextConsumerHook } from 'contexts/fetch-error.context';
// Event Handlers
import { ProofIncomeErrorTrackingHandlers } from 'containers/proof-income/components/error/handlers/proof-income-error.tracking.handlers';
import { ProofIncomeMethodHandlers } from '../handlers/proof-income-method.handlers';
// Hooks
import { useAppTrackingHook } from 'tracking/app-tracking.hook';
// Types
import { ProofIncomeMethodHookType } from './types/proof-income-method.hook.type';

const useProofIncomeMethodHook = (): ProofIncomeMethodHookType => {
  const { iframeUrl, proofIncomeIdentificationId, selectedMethod } =
      useProofIncomeContextConsumerHook(),
    { setError } = useFetchErrorContextConsumerHook(),
    { setCurrentState } = useAppContextConsumerHook();

  const { handleTrackView: handleTrackErrorView } = useAppTrackingHook(
    ProofIncomeErrorTrackingHandlers
  );

  return {
    ...ProofIncomeMethodHandlers({
      handleTrackErrorView,
      proofIncomeIdentificationId,
      setCurrentState,
      setError,
    }),
    iframeUrl,
    selectedMethod,
  };
};

export { useProofIncomeMethodHook };
